var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 203,
    viewBox: "0 0 244 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44:583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29988 116.6C-18.1001 49.3999 49.3999 -40.6001 142.3 26.6999C294.6 137 49.0999 252.8 4.29988 116.6Z",
    fill: "#00CC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7 30.4C154.3 -36.8 30.9999 20 26.0999 79.6C26.0999 152.9 121.5 80.8 127.5 189.5C127.5 243.5 306.1 113.8 220.7 30.4Z",
    fill: "#883DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 6.6001C115.4 10.3001 128.6 16.7001 142.3 26.7001C229.2 89.6001 186.6 154.3 125.7 173C111.2 88.5001 26.0999 148.9 26.0999 79.6001C28.5999 49.1001 62.0999 19.4001 103 6.6001Z",
    fill: "#051E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.2 117V137.3C100.2 139.3 98.5998 140.9 96.5998 140.9H89.3998C87.3998 140.9 85.7998 139.3 85.7998 137.3V93.8999C85.7998 93.6999 85.7998 93.4999 85.7998 93.2999C85.7998 92.2999 85.7998 91.2999 85.7998 90.2999C85.7998 64.9999 96.5998 61.3999 121.9 61.3999C147.2 61.3999 158 64.9999 158 90.2999C158 115.6 147.2 119.2 121.9 119.2C117.6 119.2 113.3 119.1 109.1 118.7C107 118.5 105.4 116.8 105.4 114.7V108.3C105.4 106.1 107.2 104.2 109.5 104.2C109.7 104.2 109.9 104.2 110.2 104.3C114.1 104.8 118 105 122 104.8C135.9 104.8 143.7 104.8 143.7 90.3999C143.7 75.9999 136.5 75.9999 122 75.9999C107.7 75.9999 100.5 75.9999 100.3 89.9999V89.9999C100.3 90.0999 100.3 90.1999 100.3 90.2999C100.3 90.3999 100.3 90.4999 100.3 90.5999L100.2 117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44:583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243.8,
    height: 202.3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5c842025dfd1d9e1a87fdd8cc8d248c7.svg";
export { ForwardRef as ReactComponent };